export default ({ request }) => ({
    ecomHxSkuInvFtyLocationListApi(data = {}) {
      return request({
        url: '/ecom/hx/sku/inv/fty/location/list',
        method: 'POST',
        data
      })
    }
  })
  